import React, { useEffect, useState } from "react";
import {useCookies} from "react-cookie";
import { DEFAULT_HEADERS, to_API_URL } from "../Services/RestService";
const OptionListMgnmtPage:React.FC<any> = (props) => {
    return (
        <div>
            <ListEditor  selectableSource="DISEASES" />
        </div>
    )
}

interface IListEditorProps{
    selectableSource: string;
}

interface ISelectableDto{
    id?: number;
    key:string;
    en: string;
    es: string;
}

const ListEditor:React.FC<IListEditorProps> = (props) => {
    const [items,setItems] = useState<ISelectableDto[]>([]);
    const [newItem,setNewItem] = useState<ISelectableDto>({key:"",en:"",es:""});
    const [cookies] = useCookies(["accessToken"]);
    
    
    useEffect(()=>{
        load();
    },[])

    async function load(){
      const response = await fetch(to_API_URL("api/v1/health/option_list?source="+props.selectableSource),{
        method:"GET",
        headers:{
            ...DEFAULT_HEADERS,
            "Authorization": "Bearer " + cookies.accessToken
        }
        });
        console.log("response",response);
    }

    function onItemAdded(item:ISelectableDto){
        if(items.includes(item)){
            setItems(items.filter(it => it.key != item.key).slice(0));
        } else {
            setItems([...items,item])
        }
    }

    function handleEditItem(item: ISelectableDto){
        setNewItem(item);
    }

    return (
    <div>
        <div>{"key"}</div>
        <input value={newItem.key} onChange={e => handleEditItem({...newItem,key:e.currentTarget.value})} />
        <div>{"en"}</div>
        <input onChange={e => e.currentTarget.value} />
        <div>{"es"}</div>
        <input onChange={e => e.currentTarget.value} />
    </div>
    )
}

export default OptionListMgnmtPage;